<template>
  <div class="">
    <HorizontalNav :navs="navs" />

    <section class="mt-4">
      <router-view></router-view>
    </section>
  </div>
</template>

<script>
import HorizontalNav from "@/components/staff/verification/HorizontalNav.vue";
export default {
  name: "StaffVerification",
  data() {
    return {
      navs: [
        { title: "Bio-Data", link: "Staff Bio Data" },
        { title: "Document Upload", link: "Staff Document Upload" },
        { title: "NIN Verification", link: "Staff NIN Verification" },
        { title: "BVN Verification", link: "Staff Bvn Verification" },
        { title: "Verification Print Out", link: "Staff Verification Summary" },
      ],
    };
  },
  components: {
    HorizontalNav,
  },

  created() {
    // this.$store.dispatch("staff/getProfile");
  },
};
</script>
